<template>
  <div v-if='showLoading'
       class='chat-box-login flex justify-center items-center absolute wp-100 hp-100 z-2'
       style='background-color: rgba(255, 255, 255, .75)'>
    <span class="">
      <span class='spinner-outer'>
        <span class="spinner-border" role="status" aria-hidden="true"></span>
      </span>
    </span>
  </div>
  <div class="relative cover min-vh-100 z-1" style='z-index: 1'>
    <div>
      <div class="traveller-login pa-10 bg-white tl">
        <form @submit.prevent novalidate>
          <div class='group-avatar flex justify-around'>
            <div class='relative flex items-end'>
              <div class='w-80 h-80 br-14 user-avatar'
                   :style='`background-image: url("${ASSETS_CDN}/images/user/elodie-nugent.png"); transform: rotate(-15deg) translateX(25px);`'></div>
              <div class='w-100 h-100 br-14 relative z-2 user-avatar'
                   :style='`background-image: url("${ASSETS_CDN}/images/user/designerjourneys-avt.png");`'></div>
              <div class='w-80 h-80 br-14 user-avatar'
                   :style='`background-image: url("${avatarLD?.size?.size1 || avatarLD?.url}"); transform: rotate(15deg) translateX(-25px);`'></div>
            </div>
          </div>
          <div class='fs-24 lh-32 fw-700 mt-12 mb-12 tc'>Hi there 👋</div>
          <div v-if="!newUser" class="fs-16 lh-20 mb-20">{{topLabelInput}}</div>
          <div class="mb-20">
            <label class="ttu fw-900 fs-11 gray-dark mb-8 dib" for="email">email</label>
            <div class="relative" v-if="showChatButton">
              <Input
               type="text"
               placeholder="Email"
               name="email"
               id="email"
               autocomplete="email"
               v-model="dataPost.email"
               @blur="handleVerifyEmail"
               @focus="handleDisableFields"
               :isCard="true">
                <template #loading v-if="verifyWait">
                  <span class="absolute right-0 top-0 w-36 h-40">
                    <span class='spinner-outer'>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </span>
                  </span>
                </template>
              </Input>
            </div>
            <Input v-else
              type="text"
              placeholder="Email"
              name="email"
              id="email"
              autocomplete="email"
              v-model="dataPost.email"
            ></Input>
            <div class="error-message" v-if="errors.email">
              {{ errors.email }}
            </div>
            <div class="error-message" v-if="msgErr && !errors.email && !showLabelPassword">
              {{ msgErr}}
            </div>
          </div>
          <div v-if="newUser" class="flex mb-flex-wrap">
              <div class="mb-20 pr-20 mb-pr-0 mb-wp-100">
                <label
                  class="ttu fw-900 fs-11 gray-dark mb-8 dib"
                  for="firstname"
                  >first name</label
                >
                <Input
                  type="text"
                  placeholder="First Name"
                  name="firstname"
                  id="firstname"
                  autocomplete="given-name"
                  v-model="dataPost.fname"
                  :extraClass="verifyEmailDone ? '' : 'disabled '"
                  :disabled="verifyEmailDone ? false : true"
                ></Input>
                <div class="error-message" v-if="errors.first_name">
                  {{ errors.first_name.split('_').join(' ') }}
                </div>
              </div>
              <div class="mb-20 mb-wp-100">
                <label
                  class="ttu fw-900 fs-11 gray-dark mb-8 dib"
                  for="lastname"
                  >last name</label
                >
                <Input
                  type="text"
                  placeholder="Last Name"
                  name="lastname"
                  id="lastname"
                  autocomplete="family-name"
                  v-model="dataPost.lname"
                  :extraClass="verifyEmailDone ? '' : 'disabled '"
                  :disabled="verifyEmailDone ? false : true"
                ></Input>
                <div class="error-message" v-if="errors.last_name">
                  {{ errors.last_name.split('_').join(' ') }}
                </div>
              </div>
            </div>
          <div v-if="newUser" class="mb-20">
            <label class="ttu fw-900 fs-11 gray-dark mb-8 dib" for="phone"
              >phone</label
            >
            <CountrySelect
              typeCountry="text"
              placeholderCountry="Country"
              placeholderPhone="Phone Number"
              v-model:country="dataPost.nationality"
              v-model:phone="dataPost.phone"
              :extraClass="verifyEmailDone ? '' : 'pointer-none disabled'"
            ></CountrySelect>
            <div class="error-message" v-if="errors.phone">
              {{ errors.phone }}
            </div>
          </div>

          <div class="mb-20" v-if="showLabelPassword">
            <label class="ttu fw-900 fs-11 gray-dark mb-8 dib" for="password">
              {{ labelPassword }}
            </label>
            <span v-if="!newUser"
                  :class="['fs-12 lh-15 underline fr',verifyEmailDone ? 'hand' : 'pointer-none']"
                  @click="toForgotPass">
              Forgot password?
            </span>
            <Input v-if="labelPassword === 'create password'"
              type="password"
              placeholder="Password"
              name="password"
              id="password"
              :autocomplete="'new-password'"
              v-model="dataPost.userpass"
              :extraClass="verifyEmailDone ? '' : 'disabled'"
              :disabled="verifyEmailDone ? false : true"
            ></Input>
            <Input v-else
              type="password"
              placeholder="Password"
              name="password"
              id="password"
              :autocomplete="'password'"
              v-model="dataPost.userpass"
              :extraClass="verifyEmailDone ? '' : 'disabled'"
              :disabled="verifyEmailDone ? false : true"
            ></Input>
            <div class="error-message" v-if="errors.password || msgErr">

                <span v-html="errors.password  || msgErr"></span>
            </div>
          </div>
          <div v-if="newUser" class="flex items-center mb-20 mb-mb-30">
            <CheckBox
              id="agreement"
              name="agreement"
              label=""
              v-model="dataPost.check_newsletter"
            ></CheckBox>
            <span class="fs-12 lh-15 gray-dark">
              I agree to receive information and deals from Designer Journeys.
              I agree with my personal data being stored and used to receive
              the newsletter.
            </span>
          </div>
          <button v-if="!showChatButton" type="submit" class="button button-brand-800 wp-100" @click="handleVerifyEmail">Continue</button>
          <button v-if="showChatButton" type="submit"
                  :disabled="verifyEmailDone ? false : true"
                  :class="['button button-brand-800 wp-100', verifyEmailDone ? '' : 'disabled']"
                  @click.prevent="apiRequestChat">Chat Now</button>
        </form>
      </div>
    </div>
  </div>
  <SectionForgotPassword v-model:modalResetActive="modalActive" :emailInput="dataPost.email" />
</template>
<script>
import axios from 'axios'
import Input from '~/components/ui/input/Input.vue'
import CountrySelect from '~/components/ui/country-selectbox/CountrySelect'
import parsePhoneNumber from 'libphonenumber-js'
import CheckBox from '~/components/ui/checkbox/CheckBox'
import {reactive, ref, watchEffect, computed, onMounted} from 'vue'
import useFormValidation from '~/utils/validators'
import { getCookie, setCookie } from '~/mixins/cookie'
import SectionForgotPassword from "~/components/sections/SectionForgotPassword/SectionForgotPassword"
import {useRoute} from 'vue-router'
import { getCountryPhone, publicDomain, assetCDN } from '~/helper'
import {requestChatURL} from "~/composables/api/apiDomain"
import {load} from "recaptcha-v3";
import { useAuthStore } from '~/store/pinia/auth'
// import {isEmpty} from "../../../helper";

export default {
  name: "chat-form",
  emits: ['requestChat'],
  props: {
    clientId: {
      require: true,
      type: [String, Number]
    },
    tripId: {
      require: true,
      type: [String, Number]
    },
    avatarLD: { type: Object, default: () => {}}
  },
  components:{
    SectionForgotPassword,
    Input,
    CountrySelect,
    CheckBox,
  },
  setup(props, { emit }){
    const domain = publicDomain()
    // const router = useRouter()
    const authStore = useAuthStore()
    const route = useRoute()
    const {
      validateNameField,
      validateEmailField,
      validatePhoneNumberField,
      validatePasswordField,
      errors,
    } = useFormValidation()
    const isErr = ref(0)
    const msgErr = ref(null)
    const dataPost = reactive ({
      fname: '',
      lname: '',
      email: '',
      userpass: '',
      phone: '',
      nationality: '',
      random_trip: 0,
      trip_id: props.tripId,
      client : props.clientId,
      check_newsletter: true,
      // add more params
      currency: getCookie('dj_curr'),
      ip_address: window.client_addr || '',
      country_code: getCookie('country_code'),
      country_name: getCookie('country_name'),
      region_name: getCookie('region_name'),
      city_name: getCookie('city_name')
    })
    const ASSETS_CDN = assetCDN()
    const showLoading = ref(false)

    /* Watch format number phone */
    watchEffect(()=>{
      let phoneNumber = parsePhoneNumber(dataPost.phone, dataPost.nationality)
      if (phoneNumber) {
        dataPost.phone = phoneNumber.nationalNumber
      }
    })

    const modalActive= ref(false)
    const toForgotPass = () =>{
      // router.push({ name: 'forgot-password'})
      if( verifyEmailDone.value) modalActive.value = !modalActive.value
    }

    const topLabelInput = ref('Please fill in your email address to continue to chat.')
    const showChatButton = ref(false)
    const newUser = ref(false)
    const showLabelPassword = ref(false)
    const labelPassword = ref('')
    const verifyEmailDone = ref(false)
    const verifyWait = ref(false)
    const preEmail = ref('')

    const isCustomer = computed(() => authStore.auth.is_customer)
    const isValid = computed(() => authStore.auth.is_valid)

    const handleVerifyEmail = async() => {
      if(!showChatButton.value) {
        validateEmailField('email', dataPost.email, 'auth')
      }

      if(preEmail.value !== dataPost.email) {
        msgErr.value = ""
        verifyEmailDone.value = false
        verifyWait.value = true
        errors.first_name = ''
        errors.last_name = ''
        errors.email = ''
        errors.phone = ''
        errors.password = ''

        const res = await authStore.verifyEmail(
          {
            email: dataPost.email,
            source: 'chat'
          })

        if(res.error === 0){
          showChatButton.value = true
          showLabelPassword.value = true
          if(isValid.value === 1 && isCustomer.value === 1){
            labelPassword.value = 'password'
            topLabelInput.value = 'Please enter your password to sign in to start chat.'
            newUser.value = false
          } else if(isValid.value === 1 && isCustomer.value === undefined){
            labelPassword.value = 'create password'
            newUser.value = true
            dataPost.userpass = ''
          }
          verifyEmailDone.value = true
          verifyWait.value = false
        } else{
          verifyWait.value = false
          msgErr.value = res.message
        }
      }
      else {
        verifyEmailDone.value = true
      }
    }

    const apiRequestChat = async () => {

      // if(verifyEmailDone.value) {
        validateNameField('first_name', dataPost.fname)
        validateNameField('last_name', dataPost.lname)
        validateEmailField('email', dataPost.email, 'auth')
        validatePhoneNumberField('phone', dataPost.phone, dataPost.nationality)
        validatePasswordField('password', dataPost.userpass)
        if (
          (newUser.value &&
            !errors.first_name &&
            !errors.last_name &&
            !errors.email &&
            !errors.phone &&
            !errors.password) ||
          (!newUser.value && !errors.email && !errors.password)
        ) {
          isErr.value = 0
          msgErr.value = null
          
          showLoading.value = true
          
          let country_code = dataPost.nationality || getCookie('country_code=')
          let dial_code = getCountryPhone(country_code)
          // dataPost.phone = isEmpty(dataPost.phone) ? '' : dial_code.concat(dataPost.phone)
          dataPost.country_gallery = route.name === 'gallery-local-designers' ? route.params.country : undefined
          dataPost.redirect_url = route.path

          const recaptcha = await load(`${useAppConfig().siteKeyGreCaptcha}`)
          const token = await recaptcha.execute('submit')

          dataPost['g-recaptcha-response'] = token

          let params = Object.assign({}, dataPost)
          params.phone = dataPost.phone ? dial_code.concat(dataPost.phone) : ''

          axios.post(requestChatURL, params).then((response) => {
            let result = response.data
            if((result.status && result.status === "ERROR") || !result.status) {
              showLoading.value = false
              msgErr.value = result.message
              isErr.value = 1
            }
            if(result.status && result.status === "SUCCESS") {
              if(result?.user_chat?.user_type === 'TV' && domain === 'traveller') {
                setCookie('is_verified', 1, 365)
                setCookie('dj_xxer_hash',  result.user_chat.hash, 365)
                authStore.setUserChatLogin(result.user_chat)
                emit('requestChat', result)
              }
              else window.location.href = `${useAppConfig().publicDomainAgent}/authenticate/autologin?hash=${result?.user_chat?.hash}`
            }
          }).catch(err => {
            showLoading.value = false
            console.log(err)
            throw new Error('Api requestChat error (form) : ', { cause: err })
          });
        }
        // e.preventDefault()
      // }

    }

    const handleDisableFields = () => {
      verifyEmailDone.value = false
      preEmail.value = dataPost.email
    }

    onMounted(() => {
      errors.first_name = ''
      errors.last_name = ''
      errors.email = ''
      errors.phone = ''
      errors.password = ''
    })

    return {
      dataPost,
      msgErr,
      isErr,
      apiRequestChat,
      errors,
      handleVerifyEmail,
      showLabelPassword,
      labelPassword,
      toForgotPass, newUser, showChatButton, topLabelInput,
      modalActive, handleDisableFields, verifyEmailDone, verifyWait,
      preEmail,
      ASSETS_CDN,
      showLoading
    }
  }
}
</script>
<style lang='scss' scoped>
//@import "~/assets/scss/src/_spinner.scss";
  .user-avatar {
    background-repeat: no-repeat; background-position: center; background-size: cover; background-color: #DFDFDF; box-shadow: 0px -5px 12px 0px rgba(0, 0, 0, 0.55) inset, 0px 2px 12px 0px rgba(0, 0, 0, 0.55) inset;
  }
</style>
